module.exports = __webpack_public_path__ + "img/selectActive.bf4a222e.svg";